import React from 'react'
import Header from '../component/Header/Header'
import HomeHero from '../component/HomeHero/HomeHero'
import Footer from '../component/Footer/Footer'

function TermofServices() {
  return (
     <>
     <Header/>
    <HomeHero
            heading='Term of Conditions'
            content=''
            textCtaBlack={true}
            headingBlack={true}
            showLogo={false}
            plainCta={false}
            bgImage={"/images/creatives/gradient-bg-3.png"}
            fullWidth={true}
            textCenter={true}
            largePara={false}
            btn={false}
        />
    
        <div className='container terms-service-content' dangerouslySetInnerHTML={{__html:renderData}}></div>
          <Footer
          newsletterSection={false}
        />
    </>
  )
}

const renderData = `
<div class=WordSection1>

<p class=MsoNormal style='margin-bottom:15.0pt;line-height:normal;background:transparent'><span style='font-size:12.0pt;font-family:sans-serif;color:#868686'>These
Terms and Conditions (&quot;Terms&quot;, &quot;Terms and Conditions&quot;)
govern your relationship with https://thetorontoclinic.com website (the
&quot;Service&quot;) operated by The Toronto Clinic (&quot;us&quot;,
&quot;we&quot;, or &quot;our&quot;).</span></p>

<p class=MsoNormal style='margin-top:15.0pt;margin-right:0in;margin-bottom:
15.0pt;margin-left:0in;line-height:normal;background:transparent'><span
style='font-size:12.0pt;font-family:sans-serif;color:#868686'>Please read
these Terms and Conditions carefully before using the Service.</span></p>

<p class=MsoNormal style='margin-top:15.0pt;margin-right:0in;margin-bottom:
15.0pt;margin-left:0in;line-height:normal;background:transparent'><span
style='font-size:12.0pt;font-family:sans-serif;color:#868686'>Your access
to and use of the Service is based on your acceptance of and compliance with
these Terms. These Terms apply to all visitors, users and others who access or
use the Service.</span></p>

<p class=MsoNormal style='margin-top:15.0pt;margin-right:0in;margin-bottom:
15.0pt;margin-left:0in;line-height:normal;background:transparent'><span
style='font-size:12.0pt;font-family:sans-serif;color:#868686'>By accessing
or using the Service you agree to be bound by these Terms and accept all legal
consequences. If you do not agree to these terms and conditions, in whole or in
part, please do not use the Service.</span></p>

<p class=MsoNormal style='margin-top:30.0pt;margin-right:0in;margin-bottom:
15.0pt;margin-left:0in;line-height:normal;background:transparent'><b><span
style='font-size:21.0pt;font-family:sans-serif;color:#595C5E'>Purchases</span></b></p>

<p class=MsoNormal style='margin-top:15.0pt;margin-right:0in;margin-bottom:
15.0pt;margin-left:0in;line-height:normal;background:transparent'><span
style='font-size:12.0pt;font-family:sans-serif;color:#868686'>If you wish
to purchase any product or service made available through the Service
(&quot;Purchase&quot;), you may be asked to supply certain information relevant
to your Purchase including, without limitation, your credit card number, the
expiration date of your credit card, your billing address, and your shipping information.</span></p>

<p class=MsoNormal style='margin-top:15.0pt;margin-right:0in;margin-bottom:
15.0pt;margin-left:0in;line-height:normal;background:transparent'><span
style='font-size:12.0pt;font-family:sans-serif;color:#868686'>You
represent and warrant that: (i) you have the legal right to use any credit
card(s) or other payment method(s) in connection with any Purchase; and that
(ii) the information you supply to us is true, correct and complete.</span></p>

<p class=MsoNormal style='margin-top:15.0pt;margin-right:0in;margin-bottom:
15.0pt;margin-left:0in;line-height:normal;background:transparent'><span
style='font-size:12.0pt;font-family:sans-serif;color:#868686'>By
submitting such information, you grant us the right to provide the information
to third parties for purposes of facilitating the completion of Purchases.</span></p>

<p class=MsoNormal style='margin-top:30.0pt;margin-right:0in;margin-bottom:
15.0pt;margin-left:0in;line-height:normal;background:transparent'><b><span
style='font-size:21.0pt;font-family:sans-serif;color:#595C5E'>Availability,
Errors and Inaccuracies</span></b></p>

<p class=MsoNormal style='margin-top:15.0pt;margin-right:0in;margin-bottom:
15.0pt;margin-left:0in;line-height:normal;background:transparent'><span
style='font-size:12.0pt;font-family:sans-serif;color:#868686'>In order to
provide exceptional service, and accuracy, we regularly update the products and
services on the Service.</span></p>

<p class=MsoNormal style='margin-top:15.0pt;margin-right:0in;margin-bottom:
15.0pt;margin-left:0in;line-height:normal;background:transparent'><span
style='font-size:12.0pt;font-family:sans-serif;color:#868686'>We cannot
and do not guarantee the accuracy or completeness of any information, including
prices, product images, specifications, availability, and services. We reserve
the right to change or update information and to correct errors, inaccuracies,
or omissions at any time without prior notice.</span></p>

<p class=MsoNormal style='margin-top:15.0pt;margin-right:0in;margin-bottom:
15.0pt;margin-left:0in;line-height:normal;background:transparent'><span
style='font-size:12.0pt;font-family:sans-serif;color:#868686'>Despite our
best efforts, the products or services available on our Service may have an
error regarding the price, be inaccurately described, or be unavailable.</span></p>

<p class=MsoNormal style='margin-top:15.0pt;margin-right:0in;margin-bottom:
15.0pt;margin-left:0in;line-height:normal;background:transparent'><span
style='font-size:12.0pt;font-family:sans-serif;color:#868686'>We may
experience delays in updating information on the Service and in our advertising
on other websites.</span></p>

<p class=MsoNormal style='margin-top:30.0pt;margin-right:0in;margin-bottom:
15.0pt;margin-left:0in;line-height:normal;background:transparent'><b><span
style='font-size:21.0pt;font-family:sans-serif;color:#595C5E'>Contests,Sweepstakes
and Promotions</span></b></p>

<p class=MsoNormal style='margin-top:15.0pt;margin-right:0in;margin-bottom:
15.0pt;margin-left:0in;line-height:normal;background:transparent'><span
style='font-size:12.0pt;font-family:sans-serif;color:#868686'>Any
contests, sweepstakes or other promotions (collectively,
&quot;Promotions&quot;) made available through the Service may be governed by
rules that are separate from these Terms. If you participate in any Promotions,
please review the applicable rules as well as our Privacy Policy. If the rules
for a Promotion conflict with these Terms, the Promotion rules will apply.</span></p>

<p class=MsoNormal style='margin-top:15.0pt;margin-right:0in;margin-bottom:
15.0pt;margin-left:0in;line-height:normal;background:transparent'><span
style='font-size:12.0pt;font-family:sans-serif;color:#868686'>Promotions
may be available for a limited time.</span></p>

<p class=MsoNormal style='margin-top:30.0pt;margin-right:0in;margin-bottom:
15.0pt;margin-left:0in;line-height:normal;background:transparent'><b><span
style='font-size:21.0pt;font-family:sans-serif;color:#595C5E'>Content</span></b></p>

<p class=MsoNormal style='margin-top:15.0pt;margin-right:0in;margin-bottom:
15.0pt;margin-left:0in;line-height:normal;background:transparent'><span
style='font-size:12.0pt;font-family:sans-serif;color:#868686'>Our Service
allows you to post, link, store, share and otherwise make available certain
information, text, graphics, videos, or other material (&quot;Content&quot;).
You are responsible for the Content that you post to the Service, including its
legality, reliability, and appropriateness.</span></p>

<p class=MsoNormal style='margin-top:15.0pt;margin-right:0in;margin-bottom:
15.0pt;margin-left:0in;line-height:normal;background:transparent'><span
style='font-size:12.0pt;font-family:sans-serif;color:#868686'>By posting
Content to the Service, you grant us the right and license to use, modify,
publicly perform, publicly display, reproduce, and distribute such Content on
and through the Service. You retain any and all of your rights to any Content
you submit, post or display on or through the Service and you are responsible
for protecting those rights. You agree that this license includes the right for
us to make your Content available to other users of the Service, who may also
use your Content subject to these Terms.</span></p>

<p class=MsoNormal style='margin-top:15.0pt;margin-right:0in;margin-bottom:
15.0pt;margin-left:0in;line-height:normal;background:transparent'><span
style='font-size:12.0pt;font-family:sans-serif;color:#868686'>You
represent and warrant that: (i) the Content is yours (you own it) or you have
the right to use it and grant us the rights and license as provided in these
Terms, and (ii) the posting of your Content on or through the Service does not
violate the privacy rights, publicity rights, copyrights, contract rights or
any other rights of any person.</span></p>

<p class=MsoNormal style='margin-top:15.0pt;margin-right:0in;margin-bottom:
15.0pt;margin-left:0in;line-height:normal;background:transparent'><span
style='font-size:12.0pt;font-family:sans-serif;color:#868686'>We reserve
all rights to block or remove communications or materials that we determine to
be: (a) abusive, defamatory, or obscene; (b) fraudulent, deceptive, or
misleading; (c) in violation of a copyright, trademark or, other intellectual
property right of another or; (d) offensive or otherwise unacceptable to us in
our sole discretion.</span></p>

<p class=MsoNormal style='margin-top:15.0pt;margin-right:0in;margin-bottom:
15.0pt;margin-left:0in;line-height:normal;background:transparent'><span
style='font-size:12.0pt;font-family:sans-serif;color:#868686'>You
acknowledge that, by providing you with the ability to view and distribute
user-generated content on the Service, we are merely acting as a passive
conduit for such distribution and is not undertaking any obligation or
liability relating to any contents or activities on the Service.</span></p>

<p class=MsoNormal style='margin-top:30.0pt;margin-right:0in;margin-bottom:
15.0pt;margin-left:0in;line-height:normal;background:transparent'><b><span
style='font-size:21.0pt;font-family:sans-serif;color:#595C5E'>Accounts</span></b></p>

<p class=MsoNormal style='margin-top:15.0pt;margin-right:0in;margin-bottom:
15.0pt;margin-left:0in;line-height:normal;background:transparent'><span
style='font-size:12.0pt;font-family:sans-serif;color:#868686'>When you
create an account with us, you must provide us information that is accurate,
complete, and current at all times. Failure to do so constitutes a breach of
the Terms, which may result in immediate termination of your account on our
Service.</span></p>

<p class=MsoNormal style='margin-top:15.0pt;margin-right:0in;margin-bottom:
15.0pt;margin-left:0in;line-height:normal;background:transparent'><span
style='font-size:12.0pt;font-family:sans-serif;color:#868686'>You are
responsible for safeguarding the password that you use to access the Service
and for any activities or actions under your password, whether your password is
with our Service or a third-party service.</span></p>

<p class=MsoNormal style='margin-top:15.0pt;margin-right:0in;margin-bottom:
15.0pt;margin-left:0in;line-height:normal;background:transparent'><span
style='font-size:12.0pt;font-family:sans-serif;color:#868686'>You agree
not to disclose your password to any third party. You must notify us
immediately upon becoming aware of any breach of security or unauthorized use
of your account.</span></p>

<p class=MsoNormal style='margin-top:15.0pt;margin-right:0in;margin-bottom:
15.0pt;margin-left:0in;line-height:normal;background:transparent'><span
style='font-size:12.0pt;font-family:sans-serif;color:#868686'>You may not
use as a username the name of another person or entity or that is not lawfully
available for use, a name or trade mark that is subject to any rights of
another person or entity other than you without appropriate authorization, or a
name that is otherwise offensive, vulgar or obscene.</span></p>

<p class=MsoNormal style='margin-top:30.0pt;margin-right:0in;margin-bottom:
15.0pt;margin-left:0in;line-height:normal;background:transparent'><b><span
style='font-size:21.0pt;font-family:sans-serif;color:#595C5E'>Intellectual
Property</span></b></p>

<p class=MsoNormal style='margin-top:15.0pt;margin-right:0in;margin-bottom:
15.0pt;margin-left:0in;line-height:normal;background:transparent'><span
style='font-size:12.0pt;font-family:sans-serif;color:#868686'>The Service
and all contents, including but not limited to text, images, graphics or code
are the property of The Toronto Clinic and are protected by copyright,
trademarks, database and other intellectual property rights. You may display
and copy, download or print portions of the material from the different areas
of the Service only for your own non-commercial use, or to place an order with
The Toronto Clinic. Any other use is strictly prohibited and may violate
copyright, trademark and other laws. These Terms do not grant you a license to
use any trademark of The Toronto Clinic or its affiliates. You further agree
not to use, change or delete any proprietary notices from materials downloaded
from the Service.</span></p>

<p class=MsoNormal style='margin-top:30.0pt;margin-right:0in;margin-bottom:
15.0pt;margin-left:0in;line-height:normal;background:transparent'><b><span
style='font-size:21.0pt;font-family:sans-serif;color:#595C5E'>Links
To Other Web Sites</span></b></p>

<p class=MsoNormal style='margin-top:15.0pt;margin-right:0in;margin-bottom:
15.0pt;margin-left:0in;line-height:normal;background:transparent'><span
style='font-size:12.0pt;font-family:sans-serif;color:#868686'>The Service
may contain links to third-party web sites or services that are not owned or
controlled by The Toronto Clinic.</span></p>

<p class=MsoNormal style='margin-top:15.0pt;margin-right:0in;margin-bottom:
15.0pt;margin-left:0in;line-height:normal;background:transparent'><span
style='font-size:12.0pt;font-family:sans-serif;color:#868686'>The Toronto
Clinic has no control over, and assumes no responsibility for, the content,
privacy policies, or practices of any third party web sites or services. You
further acknowledge and agree that The Toronto Clinic shall not be responsible
or liable, directly or indirectly, for any damage or loss caused or alleged to
be caused by or in connection with use of or reliance on any such content,
goods or services available on or through any such websites or services.</span></p>

<p class=MsoNormal style='margin-top:15.0pt;margin-right:0in;margin-bottom:
15.0pt;margin-left:0in;line-height:normal;background:transparent'><span
style='font-size:12.0pt;font-family:sans-serif;color:#868686'>We strongly
advise you to read the terms and conditions and privacy policies of any
third-party web sites or services that you visit.</span></p>

<p class=MsoNormal style='margin-top:30.0pt;margin-right:0in;margin-bottom:
15.0pt;margin-left:0in;line-height:normal;background:transparent'><b><span
style='font-size:21.0pt;font-family:sans-serif;color:#595C5E'>Termination</span></b></p>

<p class=MsoNormal style='margin-top:15.0pt;margin-right:0in;margin-bottom:
15.0pt;margin-left:0in;line-height:normal;background:transparent'><span
style='font-size:12.0pt;font-family:sans-serif;color:#868686'>We may
terminate or suspend access to our Service immediately, without prior notice or
liability, for any reason whatsoever, including, without limitation, if you
breach the Terms.</span></p>

<p class=MsoNormal style='margin-top:15.0pt;margin-right:0in;margin-bottom:
15.0pt;margin-left:0in;line-height:normal;background:transparent'><span
style='font-size:12.0pt;font-family:sans-serif;color:#868686'>All
provisions of the Terms shall survive termination, including, without
limitation, ownership provisions, warranty disclaimers, indemnity and
limitations of liability.</span></p>

<p class=MsoNormal style='margin-top:15.0pt;margin-right:0in;margin-bottom:
15.0pt;margin-left:0in;line-height:normal;background:transparent'><span
style='font-size:12.0pt;font-family:sans-serif;color:#868686'>Upon
termination, your right to use the Service will immediately cease. If you wish
to terminate your account, you may simply discontinue using the Service.</span></p>

<p class=MsoNormal style='margin-top:30.0pt;margin-right:0in;margin-bottom:
15.0pt;margin-left:0in;line-height:normal;background:transparent'><b><span
style='font-size:21.0pt;font-family:sans-serif;color:#595C5E'>Indemnification</span></b></p>

<p class=MsoNormal style='margin-top:15.0pt;margin-right:0in;margin-bottom:
15.0pt;margin-left:0in;line-height:normal;background:transparent'><span
style='font-size:12.0pt;font-family:sans-serif;color:#868686'>You agree to
indemnify, defend and hold harmless The Toronto Clinic, its principals,
officers, directors, representatives, employees, contractors, licensors,
licensees, suppliers and agents, from and against any claims, losses, damages,
losses, obligations, costs, actions or demands.</span></p>

<p class=MsoNormal style='margin-top:15.0pt;margin-right:0in;margin-bottom:
15.0pt;margin-left:0in;line-height:normal;background:transparent'><span
style='font-size:12.0pt;font-family:sans-serif;color:#868686'>These
include but are not limited to: (a) legal and accounting fees resulting from
your use of the Service; (b) your breach of any of these Terms; (c) anything
you post on or upload to the Service; and (d) any activity related to your
account. This includes any negligent or illegal conduct by you, any person or
entity accessing the Service using your account whether such access is obtained
via fraudulent or illegal means.</span></p>

<p class=MsoNormal style='margin-top:30.0pt;margin-right:0in;margin-bottom:
15.0pt;margin-left:0in;line-height:normal;background:transparent'><b><span
style='font-size:21.0pt;font-family:sans-serif;color:#595C5E'>Limitation
Of Liability</span></b></p>

<p class=MsoNormal style='margin-top:15.0pt;margin-right:0in;margin-bottom:
15.0pt;margin-left:0in;line-height:normal;background:transparent'><span
style='font-size:12.0pt;font-family:sans-serif;color:#868686'>The Toronto
Clinic, its directors, employees, partners, agents, suppliers, or affiliates,
shall not be liable for any loss or damage, direct or indirect, incidental,
special, consequential or punitive damages, including without limitation,
economic loss, loss or damage to electronic media or data, goodwill, or other
intangible losses, resulting from (i) your access to or use of the Service;
(ii) your inability to access or use the Service; (iii) any conduct or content
of any third-party on or related to the Service; (iiv) any content obtained
from or through the Service; and (v) the unauthorized access to, use of or
alteration of your transmissions or content, whether based on warranty,
contract, tort (including negligence) or any other claim in law, whether or not
we have been informed of the possibility of such damage, and even if a remedy
set forth herein is found to have failed of its essential purpose.</span></p>

<p class=MsoNormal style='margin-top:30.0pt;margin-right:0in;margin-bottom:
15.0pt;margin-left:0in;line-height:normal;background:transparent'><b><span
style='font-size:21.0pt;font-family:sans-serif;color:#595C5E'>Disclaimer
And Non-Waiver of Rights</span></b></p>

<p class=MsoNormal style='margin-top:15.0pt;margin-right:0in;margin-bottom:
15.0pt;margin-left:0in;line-height:normal;background:transparent'><span
style='font-size:12.0pt;font-family:sans-serif;color:#868686'>The Toronto
Clinic makes no guarantees, representations or warranties of any kind as
regards the website and associated technology. Any purportedly applicable
warranties, terms and conditions are excluded, to the fullest extent permitted
by law. Your use of the Service is at your sole risk. The Service is provided
on an &quot;AS IS&quot; and &quot;AS AVAILABLE&quot; basis. The Service is
provided without warranties of any kind, whether express or implied, including,
but not limited to, implied warranties of merchantability, fitness for a
particular purpose, non-infringement or course of performance, except as
provided for under the laws of any province in Canada. In such cases, the
provincial law shall apply to the extent necessary.</span></p>

<p class=MsoNormal style='margin-top:15.0pt;margin-right:0in;margin-bottom:
15.0pt;margin-left:0in;line-height:normal;background:transparent'><span
style='font-size:12.0pt;font-family:sans-serif;color:#868686'>The Toronto
Clinic its subsidiaries, affiliates, and its licensors do not warrant that a)
the Service will function uninterrupted, secure or available at any particular
time or location; b) any errors or defects will be corrected; c) the Service is
free of viruses or other harmful components; or d) the results of using the
Service will meet your requirements.</span></p>

<p class=MsoNormal style='margin-top:15.0pt;margin-right:0in;margin-bottom:
15.0pt;margin-left:0in;line-height:normal;background:transparent'><span
style='font-size:12.0pt;font-family:sans-serif;color:#868686'>If you
breach any of these Terms and The Toronto Clinic chooses not to immediately
act, or chooses not to act at all, The Toronto Clinic will still be entitled to
all rights and remedies at any later date, or in any other situation, where you
breach these Terms. The Toronto Clinic does not waive any of its rights. The
Toronto Clinic shall not be responsible for any purported breach of these Terms
caused by circumstances beyond its control. A person who is not a party to
these Terms shall have no rights of enforcement.</span></p>

<p class=MsoNormal style='margin-top:15.0pt;margin-right:0in;margin-bottom:
15.0pt;margin-left:0in;line-height:normal;background:transparent'><span
style='font-size:12.0pt;font-family:sans-serif;color:#868686'>You may not
assign, sub-license or otherwise transfer any of your rights under these Terms.</span></p>

<p class=MsoNormal style='margin-top:30.0pt;margin-right:0in;margin-bottom:
15.0pt;margin-left:0in;line-height:normal;background:transparent'><b><span
style='font-size:21.0pt;font-family:sans-serif;color:#595C5E'>Exclusions</span></b></p>

<p class=MsoNormal style='margin-top:15.0pt;margin-right:0in;margin-bottom:
15.0pt;margin-left:0in;line-height:normal;background:transparent'><span
style='font-size:12.0pt;font-family:sans-serif;color:#868686'>As set out,
above, some jurisdictions do not allow the exclusion of certain warranties or
the exclusion or limitation of liability for consequential or incidental
damages, so the limitations above may not apply to you. Provincial laws of
Canada may apply to certain products and service provided.</span></p>

<p class=MsoNormal style='margin-top:30.0pt;margin-right:0in;margin-bottom:
15.0pt;margin-left:0in;line-height:normal;background:transparent'><b><span
style='font-size:21.0pt;font-family:sans-serif;color:#595C5E'>Governing
Law</span></b></p>

<p class=MsoNormal style='margin-top:15.0pt;margin-right:0in;margin-bottom:
15.0pt;margin-left:0in;line-height:normal;background:transparent'><span
style='font-size:12.0pt;font-family:sans-serif;color:#868686'>These Terms
shall be governed by, and interpreted and enforced in accordance with, the laws
in the Province of Ontario and the laws of Canada, as applicable.</span></p>

<p class=MsoNormal style='margin-top:15.0pt;margin-right:0in;margin-bottom:
15.0pt;margin-left:0in;line-height:normal;background:transparent'><span
style='font-size:12.0pt;font-family:sans-serif;color:#868686'>If any
provision of these Terms is held to be invalid or unenforceable by a court of
competent jurisdiction, then any remaining provisions of these Terms will
remain in effect. These Terms constitute the entire agreement between us
regarding our Service, and supersede and replace any prior agreements, oral or
otherwise, regarding the Service.</span></p>

<p class=MsoNormal style='margin-top:30.0pt;margin-right:0in;margin-bottom:
15.0pt;margin-left:0in;line-height:normal;background:transparent'><b><span
style='font-size:21.0pt;font-family:sans-serif;color:#595C5E'>Changes</span></b></p>

<p class=MsoNormal style='margin-top:15.0pt;margin-right:0in;margin-bottom:
15.0pt;margin-left:0in;line-height:normal;background:transparent'><span
style='font-size:12.0pt;font-family:sans-serif;color:#868686'>We reserve
the right, at our sole discretion, to modify or replace these Terms at any
time. If a revision is material we will make reasonable efforts to provide at
least 30 days’ notice prior to any new terms taking effect. What constitutes a
material change will be determined at our sole discretion.</span></p>

<p class=MsoNormal style='margin-top:15.0pt;margin-right:0in;margin-bottom:
15.0pt;margin-left:0in;line-height:normal;background:transparent'><span
style='font-size:12.0pt;font-family:sans-serif;color:#868686'>By
continuing to access or use our Service after those revisions become effective,
you agree to be bound by the revised terms. If you do not agree to the new
terms, in whole or in part, please stop using the website and the Service.</span></p>

<p class=MsoNormal style='margin-top:30.0pt;margin-right:0in;margin-bottom:
15.0pt;margin-left:0in;line-height:normal;background:transparent'><b><span
style='font-size:21.0pt;font-family:sans-serif;color:#595C5E'>Contact
Us</span></b></p>

<p class=MsoNormal style='margin-top:15.0pt;margin-right:0in;margin-bottom:
15.0pt;margin-left:0in;line-height:normal;background:transparent'><span
style='font-size:12.0pt;font-family:sans-serif;color:#868686'>If you have
any questions about these Terms, please&nbsp;</span><span style='color:black'><a
href="tel:416-849-5555"><span
style='font-size:12.0pt;font-family:sans-serif;color:#AE936A;text-decoration:
none'>contact us</span></a></span><span style='font-size:12.0pt;font-family:
"Adamina",serif;color:#868686'>.</span></p>

</div>
`

export default TermofServices